import { Route, Switch } from 'wouter'
import { Toaster } from 'sonner'
import { ThemeProvider } from '../components/theme-provider'
import DashboardLayout from '../app/(dashboard)/layout'
import UserLayout from '../app/(user)/layout'
import LoginPage from '../app/(auth)/login/page'
import RegisterPage from '../app/(auth)/register/page'
import DashboardPage from '../app/(dashboard)/dashboard/page'
import AnalyticsPage from '../app/(dashboard)/dashboard/analytics/page'
import KeysPage from '../app/(dashboard)/dashboard/keys/page'
import GatewayPage from '../app/(dashboard)/dashboard/gateway/page'
import DocsPage from '../app/(dashboard)/dashboard/docs/page'
import DatabasePage from '../app/(dashboard)/dashboard/database/page'
import StoragePage from '../app/(dashboard)/dashboard/storage/page'
import ConnectivityPage from '../app/(dashboard)/dashboard/connectivity/page'
import SettingsPage from '../app/(dashboard)/dashboard/settings/page'
import PortalPage from '../app/(user)/portal/page'
import PlaygroundPage from '../app/(user)/playground/page'
import GetStartedPage from '../app/(user)/get-started/page'

// Wrapper for dashboard pages that includes the layout
function DashboardRoute({ component: Component }: { component: React.ComponentType }) {
  return (
    <DashboardLayout>
      <Component />
    </DashboardLayout>
  )
}

// Wrapper for user pages that includes the layout
function UserRoute({ component: Component }: { component: React.ComponentType }) {
  return (
    <UserLayout>
      <Component />
    </UserLayout>
  )
}

function App() {
  return (
    <ThemeProvider>
      <Switch>
        <Route path="/login" component={LoginPage} />
        <Route path="/register" component={RegisterPage} />
        <Route path="/dashboard">
          {() => <DashboardRoute component={DashboardPage} />}
        </Route>
        <Route path="/dashboard/analytics">
          {() => <DashboardRoute component={AnalyticsPage} />}
        </Route>
        <Route path="/dashboard/keys">
          {() => <DashboardRoute component={KeysPage} />}
        </Route>
        <Route path="/dashboard/gateway">
          {() => <DashboardRoute component={GatewayPage} />}
        </Route>
        <Route path="/dashboard/docs">
          {() => <DashboardRoute component={DocsPage} />}
        </Route>
        <Route path="/dashboard/database">
          {() => <DashboardRoute component={DatabasePage} />}
        </Route>
        <Route path="/dashboard/storage">
          {() => <DashboardRoute component={StoragePage} />}
        </Route>
        <Route path="/dashboard/connectivity">
          {() => <DashboardRoute component={ConnectivityPage} />}
        </Route>
        <Route path="/dashboard/settings">
          {() => <DashboardRoute component={SettingsPage} />}
        </Route>
        <Route path="/portal">
          {() => <UserRoute component={PortalPage} />}
        </Route>
        <Route path="/playground">
          {() => <UserRoute component={PlaygroundPage} />}
        </Route>
        <Route path="/get-started">
          {() => <UserRoute component={GetStartedPage} />}
        </Route>
        <Route path="/">
          {() => <UserRoute component={GetStartedPage} />}
        </Route>
      </Switch>
      <Toaster />
    </ThemeProvider>
  )
}

export default App
